import { configureStore } from '@reduxjs/toolkit';

import RootReducers from './Rootreducers'; // Ensure this path and name are correct

const store = configureStore({
  reducer: RootReducers,
  devTools: process.env.NODE_ENV !== 'production',
});

export default store;
